import { ApolloProvider } from "@apollo/react-hooks";
import ApolloClient from "apollo-boost";
import fetch from "isomorphic-fetch";
import React from "react";

const uri =
  process.env.NODE_ENV === "production"
    ? // true
      "https://api.thegreeceproperty.com/graphql"
    : "http://localhost:4000/graphql";

const client = new ApolloClient({
  uri,
  fetch
});

export const wrapRootElement = ({ element }) => (
  <ApolloProvider client={client}>{element}</ApolloProvider>
);
